import { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  Button,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  DialogContentText,
  FormControlLabel,
  Paper,
  Radio,
  RadioGroup,
} from '@mui/material';
import useAuthContext from '../auth/useAuthContext';
import useUser from '../data/useUser';

function ProjectDeleteDialog({
  open, handleClose, projects, deleteProject, currentProject, setCurrentProject,
}) {
  const { user } = useAuthContext();

  const [selectedProject, setSelectedProject] = useState();
  const [deleteConfirmationOpen, setDeleteConfirmationOpen] = useState(false);

  const handleDeleteConfirmationClose = () => {
    setDeleteConfirmationOpen(false);
  };
  // const [projectId, setProjectId] = useState();
  const { updateUser } = useUser({ user });

  const handleSubmit = (event) => {
    event.preventDefault();
    handleClose();
  };

  const handleDeleteProject = (event) => {
    const { value } = event.target;
    const project = projects.find((p) => p.project === value);
    setSelectedProject(project.project);
  };

  const handleDeleteButtonClick = async () => {
    setDeleteConfirmationOpen(true);
  };

  const handleConfirmDelete = async () => {
    await deleteProject(selectedProject);
    if (currentProject === selectedProject) {
      setCurrentProject(null);
      updateUser({
        currentProject: null,
      });
    }
    setSelectedProject(null);
    setDeleteConfirmationOpen(false);
    handleClose();
  };

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>Delete Project</DialogTitle>
      <Box
        component='form'
        onSubmit={handleSubmit}
        sx={{
          width: '100%',
          m: 1,
        }}
      >
        <Paper elevation={0}>
          {projects && projects.length > 0 ? (
            <RadioGroup value={selectedProject} onChange={handleDeleteProject}>
              {projects
                && projects.map((project) => (
                  <FormControlLabel
                    value={project.project}
                    key={project.project + project.user}
                    control={<Radio />}
                    label={project.project}
                  />
                ))}
            </RadioGroup>
          ) : (
            <p>No projects to delete.</p>
          )}
          {selectedProject && (
            <Button
              onClick={handleDeleteButtonClick}
              color='error'
              sx={{
                fontWeight: 'bold',
              }}
            >
              Delete
            </Button>
          )}
        </Paper>
      </Box>
      {/* Delete Confirmation Dialog */}
      <Dialog open={deleteConfirmationOpen} onClose={handleDeleteConfirmationClose}>
        <DialogTitle>CONFIRM DELETION</DialogTitle>
        <DialogContent>
          <DialogContentText>
            <b> Are you sure you want to delete this project? </b>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDeleteConfirmationClose} variant='contained' color='primary'>
            Cancel
          </Button>
          <Button onClick={handleConfirmDelete} variant='contained' color='error'>
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </Dialog>
  );
}

ProjectDeleteDialog.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  setCurrentProject: PropTypes.func,
  projects: PropTypes.arrayOf(
    PropTypes.shape({
      project: PropTypes.string,
      user: PropTypes.string,
      description: PropTypes.string,
      languages: PropTypes.arrayOf(
        PropTypes.shape({
          name: PropTypes.string,
          code: PropTypes.string,
        }),
      ),
    }),
  ),
  deleteProject: PropTypes.func,
  currentProject: PropTypes.string,
};

ProjectDeleteDialog.defaultProps = {
  open: false,
  handleClose: () => {},
  projects: [],
  deleteProject: () => {},
  currentProject: '',
  setCurrentProject: () => {},
};

export default ProjectDeleteDialog;
